<template>
  <div class="active">
    <!-- nav -->
    <Navbar style="height: 7.3rem" />
    <!-- banner -->
    <section class="banner">
      <img src="@/assets/images/activebanner.png" alt="" />
    </section>
    <!-- info -->
    <div class="info">
      <h1>摩摩哒&王者荣耀</h1>
      <p>
        <span class="title">摩摩哒Momoda</span>
        <span>2022-10-12 15:20</span>
      </p>
      <div class="content">
        <p>
          9月21日简介介绍介绍简介介绍介绍简介介绍介绍简介介绍介绍简介介绍简介介绍介绍简介介绍介绍简介介绍介绍简介介绍介绍简介介绍简介介绍介绍简介介绍介绍简介介绍介绍简介介绍介绍简介介绍
        </p>
        <img src="@/assets/images/active1.png" alt="" />
      </div>
    </div>
    <!-- foot -->
    <Foot />
  </div>
</template>

<script>
import Navbar from "@/components/nav.vue";
import Foot from "@/components/foot.vue";
export default {
  name: "productDetail",
  components: {
    Navbar,
    Foot,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.info {
  width: 80%;
  margin: 2rem auto;
  > h1 {
    margin-bottom: 2rem;
  }
  .title {
    color: #f5bf4a;
    margin-right: 2rem;
  }
  .content {
    width: 80%;
    margin: 1rem auto;
    p {
      font-size: 1.2rem;
      color: #666;
      text-indent: 2rem;
      margin: 4rem 0;
    }
    img {
      width: 100%;
    }
  }
}
</style>
